var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var Promote = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M19.2102633,4.06953261 C19.5246293,3.96474395 19.8644213,4.13463994 19.96921,4.44900593 L19.9922525,4.54263324 L20,4.63874259 L20,17.3612574 C20,17.6926283 19.7313708,17.9612574 19.4,17.9612574 L19.3038907,17.9535099 L19.2102633,17.9304674 L11.21,15.2625798 L11.8059335,18.835601 C11.8967286,19.3803713 11.5287089,19.8955989 10.9839386,19.9863939 C10.9296071,19.9954492 10.8746204,20 10.8195396,20 L8.84712709,20 C8.35828794,20 7.94109783,19.646587 7.86073316,19.164399 L7.166,14.9995798 L6.5,15 C5.22974508,15 4.18075921,14.0526345 4.02105111,12.8259123 L4.00531768,12.6643757 L4,12.5 L4,9.5 C4,8.1745166 5.03153594,7.08996133 6.33562431,7.00531768 L6.5,7 L10.416,7 L19.2102633,4.06953261 Z M8.84712709,19 L10.8195396,19 L10.152,15 L8.18,15 L8.84712709,19 Z M19,5.193 L11,7.85957981 L11,14 L11.024,14.1475798 L19,16.806 L19,5.193 Z M10,14 L10,7.99957981 L6.5,8 C5.72030388,8 5.07955132,8.59488808 5.00686658,9.35553999 L5,9.5 L5,12.5 C5,13.2796961 5.59488808,13.9204487 6.35553999,13.9931334 L6.5,14 L10,14 Z" })));
};
Promote.displayName = 'Promote';
export default Promote;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Promote.js.map